import { DRAWER_TABS, PHASE_HEALTH_FAULTS } from '../../constants';
import type { TabKey } from '../../types';

export const TEST_ID = 'droneDetailDrawer';

export const TABS = DRAWER_TABS;

export const COMPONENTS_TAB_MIN_PHASE = 1;

export const TAB_MIN_PHASE: Record<TabKey, number> = {
    components: COMPONENTS_TAB_MIN_PHASE,
    health: 1,
    parts: PHASE_HEALTH_FAULTS,
    service: 1,
    warnings: PHASE_HEALTH_FAULTS
};
